<div [ngClass]="{ stickyContainer: mortgageCalculationService.showStickyMobileDisplay() }" aria-live="polite">
    <h2 id="assetDeficiencyLabel" class="ap-margin-top-0 ap-margin-bottom-1">
        {{ 'mortgage-calculation.asset-deficiency.title' | apContent }}
    </h2>

    @if (storeService.isCalculatingMaxMortgage) {
        <ap-spinner
            [visuallyHiddenLabel]="true"
            class="ap-margin-bottom-1"
            loadingText="{{ 'mortgage-calculation.spinner.loading' | apContent }}"
            readyText="{{ 'mortgage-calculation.spinner.ready' | apContent }}"
            state="loading"
            [size]="'small'"
            [icon]="true"
        ></ap-spinner>
    } @else {
        <ap-amount-display
            aria-busy="false"
            id="assetDeficiencyAmount"
            [value]="math.abs(assetDeficiency)"
            size="large"
            [minFractionDigits]="0"
            [maxFractionDigits]="0"
            [emphasize]="true"
            [contrast]="true"
        >
        </ap-amount-display>
    }
</div>
